import GaEvent from './GaEvent';

export default class MenuOpenedGaEvent extends GaEvent {
  constructor() {
    super('menu_opened');
  }
}
